import styled from '@emotion/styled';
// TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.
export var Icon = styled.img({
  height: '14px',
  width: '14px',
  marginRight: "var(--ds-space-050, 4px)",
  borderRadius: '2px',
  userSelect: 'none',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
});

// Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
export var AKIconWrapper = styled.span({
  marginRight: "var(--ds-space-negative-025, -2px)"
});